import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslations } from "next-intl";
import { useTheme } from "@quales/utils/theme";
import {
  WcAutoComplete,
  WcStack,
  WcTextField,
  WcTypography,
} from "@bpipartners/webui";
import { TenantAllUserTenant } from "@quales/data-access/gql-server";

interface TenantAutoCompleteProps {
  onValueChanged: any;
  edit?: boolean;
  InputPropsValue?: any;
  width?: number;
  color?: string;
  backgroundColor?: string;
  tenants?: TenantAllUserTenant[];
}

export const TenantAutoComplete = function (props: TenantAutoCompleteProps) {
  const {
    onValueChanged,
    edit,
    InputPropsValue,
    width,
    color,
    backgroundColor,
    tenants,
  } = props;
  const t = useTranslations();

  const theme = useTheme();

  const [value, setValue] = React.useState<TenantAllUserTenant | null>(null);

  const onChange = function (inputVal: any) {
    onValueChanged(inputVal);
    setValue(inputVal);
  };

  React.useEffect(() => {
    if (InputPropsValue) {
      const foundItem = tenants.find(
        //@ts-ignore
        (item) => item.tenantId === InputPropsValue
      );

      if (foundItem) {
        setValue(foundItem);
      }
    }
  }, [InputPropsValue, tenants]);

  return (
    <WcStack id="TenantAutoComplete">
      {tenants && tenants.length > 1 && (
        <WcAutoComplete
          color={color !== "" ? color : theme.appColors.onPrimary}
          id="tags-TenantAutoComplete"
          sx={{
            width: width ? width : 600,
          }}
          value={value}
          disabled={!edit}
          filterSelectedOptions
          onChange={(event, newValue) => {
            if (edit) {
              onChange(newValue);
            }
          }}
          //@ts-ignore
          getOptionLabel={(option) =>
            option && option.name ? option.name : ""
          }
          // @ts-ignore
          renderOption={(propsVal: any, option: any) => (
            <li
              {...propsVal}
              key={option.tenantId}
              color={color !== "" ? color : theme.appColors.onPrimary}
            >
              {option.name}
            </li>
          )}
          options={tenants}
          disableClearable
          defaultValue={[]}
          renderInput={(params) => (
            <WcTextField
              disabled={!edit}
              sx={{
                backgroundColor:
                  backgroundColor !== ""
                    ? backgroundColor
                    : theme.appColors.primary,
                input: {
                  color: color !== "" ? color : theme.appColors.onPrimary,
                },
              }}
              placeholder={t("labels.tenants")}
              {...params}
              hiddenLabel
            />
          )}
          popupIcon={
            <ArrowDropDownIcon
              sx={{ color: color !== "" ? color : theme.appColors.onPrimary }}
            />
          }
        />
      )}
      {tenants && tenants.length === 1 && (
        <WcTypography color={color !== "" ? color : theme.appColors.onPrimary}>
          {tenants[0].name}
        </WcTypography>
      )}
    </WcStack>
  );
};

export default TenantAutoComplete;
